import { useCallback, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { Button } from 'UIPackage/MainModule/components/Button';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { getAdminUserAdminUrl } from '../selectors/adminSelectors';
import { adminGetUserAdminUrl } from '../actions/adminAction';

interface IAdminUsersStoreProps {
  userAdminUrl: string;
}

const AdminUsersWithoutStore = ({ userAdminUrl }: IAdminUsersStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const onUrlOpen = useCallback(() => window.location.replace(userAdminUrl), [userAdminUrl]);

  useEffect(() => {
    dispatch(adminGetUserAdminUrl());
  }, [dispatch]);

  return (
    <div>
      <Button color="primary" type="button" variant="contained" onClick={onUrlOpen} text="Управление пользователями" />
    </div>
  );
};

const mapStateToProps = (state: IRootState): IAdminUsersStoreProps => ({
  userAdminUrl: getAdminUserAdminUrl(state),
});

export const AdminUsers = connect(mapStateToProps)(AdminUsersWithoutStore);
